<template>
  <div id="phone" :class="{ full: !isComponent }">
    <Agreement v-if="agree.show" @state="onAgreement($event)" />
    <div
      v-if="banner.current >= 0 && banner.show"
      ref="banner"
      class="banner animated slideInDown"
      :class="{ 'static-banner': isComponent }"
    >
      <i v-if="banner.queue[banner.current].isLightBulb" class="anyteachicon anyteach-tishi" />
      <span>{{ banner.queue[banner.current].text }}</span>
      <div class="close" v-if="!isComponent && banner.queue[banner.current].allowClose">
        <i class="anyteachicon anyteach-guanbi" @click="closeBanner('ad')" />
      </div>
    </div>
    <Inviter v-if="inviter" :name="inviter.name" :img="inviter.gravatar" />
    <div ref="container" class="container" v-if="!coupon">
      <div class="input-wrapper">
        <h3 class="title">手机号</h3>
        <div class="input" :class="{ active: state.active === 'phone' }">
          <span>+86</span>
          <input
            v-model="phone"
            type="tel"
            ref="phoneInput"
            placeholder="您的手机号码"
            @focus="state.active = 'phone'"
            @blur="state.active = null"
          />
          <i
            v-if="phone.length"
            class="animated fadeIn clear-phone anyteachicon anyteach-gary"
            @click="clearPhone"
          />
        </div>
      </div>
      <div class="input-wrapper">
        <h3 class="title">验证码</h3>
        <div class="input" :class="{ active: state.active === 'smsCode' }">
          <input
            v-model="smsCode"
            type="tel"
            placeholder="4 位验证码"
            ref="smsInput"
            @focus="state.active = 'smsCode'"
            @blur="state.active = null"
          />
          <div class="get-code" v-if="sms.state == 0" @click="sendSms()">获取短信验证码</div>
          <div class="get-code countdown" v-if="sms.state === 1">{{ sms.countdown }} 秒</div>
        </div>
      </div>
      <Agree v-model="agree.checked" :size="agree.size">
        <p class="agree">
          <span class="text" @click="agree.checked = !agree.checked">我已阅读并同意</span>
          <span class="link" @click="agree.show = true">《AnyTeach 服务条款》</span>
        </p>
      </Agree>
      <div class="btn-primary login-button" @click="submit()">
        <span v-if="!$store.state.isWechat">登录 / 注册</span>
        <span v-else>验证手机号</span>
      </div>
      <div class="btn-hint">新手机号将会自动注册</div>
      <div class="btn-back" v-if="!isComponent">
        <div @click="back">
          <div class="circle">
            <i class="anyteachicon anyteach-fanhui" />
          </div>
          <span>稍后登陆</span>
        </div>
      </div>
    </div>
    <!-- <div ref="container" class="coupon-container animated fadeIn" v-if="coupon">
      <Coupon
        v-for="(value, key) in coupon"
        :key="key"
        :coupon="value"
        :is-list-view="true"
        :isShowButton="!isComponent"
      />
      <div v-if="!isComponent" class="btn-secondary" @click="next">返回上一页</div>
      <div v-else class="btn-primary" @click="next">完成</div>
    </div>-->
  </div>
</template>

<script>
import Coupon from "@/components/public/Coupon.vue"
import Agreement from "@/components/homelesson/post/Agreement"
import Agree from "mand-mobile/lib-vw/agree"
import Inviter from "./Inviter"

export default {
  name: "Phone",
  components: {
    Coupon,
    Agree,
    Agreement,
    Inviter,
  },
  props: {
    isComponent: {
      type: Boolean,
      default: false,
    },
    allowAd: {
      type: Boolean,
      default: true,
    },
    showHint: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      agree: {
        checked: true,
        size: "lg",
        show: false,
      },
      state: {
        active: null,
        timeouts: [],
        isBindInvite: false,
      },
      isLoading: false,
      phone: "",
      sms: {
        code: "",
        state: 0,
        countdown: 60,
      },
      inviter: null,
      banner: {
        current: -1,
        show: true,
        queue: [
          {
            text: "请先登录",
            condition: this.$route.query.hint == 1 || this.showHint,
            key: "hint",
            duration: 3000,
            isLightBulb: false,
            allowClose: false,
          },
          {
            text: "新人注册即赠 100 元学习券",
            condition: this.allowAd,
            key: "hint",
            duration: 0,
            isLightBulb: true,
            allowClose: true,
          },
        ],
      },
      smsCode: "",
      numRegExp: new RegExp("^[0-9]*$"),
      coupon: null,
      loginUser: null,
    }
  },
  watch: {
    user: function (val) {
      this.loginUser = val
    },
    phone: function (newVal, oldVal) {
      if (newVal.indexOf(" ") > 0 || newVal.length > 11 || !this.numRegExp.test(newVal)) {
        this.phone = oldVal
      }
      if (newVal.length === 11 && this.numRegExp.test(newVal)) {
        localStorage.setItem("phoneInput", newVal)
        this.$refs.smsInput.focus()
      }
    },
    smsCode: function (newVal, oldVal) {
      if (newVal.length > 4 || !this.numRegExp.test(newVal)) {
        this.smsCode = oldVal
      }
      if (
        newVal.length === 4 &&
        this.numRegExp.test(newVal) &&
        this.phone.length === 11 &&
        this.numRegExp.test(this.phone)
      ) {
        this.$refs.smsInput.blur()
        this.submit()
      }
    },
    isLoading: function (val) {
      if (val) {
        this.$toastLoading("登录中...")
      } else {
        this.$toastHide()
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  methods: {
    back() {
      this.$router.push("/")
    },
    async setInviter() {
      if (!this.$route.query.inviter && !this.$route.query.friend) {
        return false
      }

      const inviter_id = this.$route.query.inviter || this.$route.query.friend

      this.inviter = await this.$api.user.FIND(inviter_id)
    },
    async bindInviter() {
      if (!this.$route.query.inviter && !this.$route.query.friend) {
        return false
      }

      if (!this.loginUser || !this.loginUser.user_id) {
        return false
      }

      const inviter_id = this.$route.query.inviter || this.$route.query.friend

      if (this.$store.state.isHandleFriend === inviter_id) {
        return false
      }

      // 防止用户绑定自己
      if (inviter_id === this.loginUser.user_id) {
        return false
      }

      const code = await this.$api.invite.BIND_INVITER(inviter_id)

      // 如果绑定失败，则不要再次发起绑定请求
      if (code === "1006") {
        return Sentry.captureException(
          `${this.loginUser.user_id} bind ${this.$route.query.inviter} failed: ${code}`,
        )
      } else {
        this.$store.commit("isHandleFriend", inviter_id)
      }
    },
    clearPhone() {
      localStorage.removeItem("phoneInput")
      this.phone = ""
    },
    onAgreement(state) {
      if (state) {
        this.agree.checked = state
      }
      this.agree.show = false
    },
    setSmsCountdown() {
      const timeout = (this.sms.countdown + 1) * 1000
      this.state.timeouts.push(
        setTimeout(() => {
          window.clearInterval(countdown)
          this.sms.countdown = timeout / 1000 - 1
          this.sms.state--
        }, timeout),
      )
      const countdown = window.setInterval(() => {
        this.sms.countdown--
      }, 1000)
    },
    async sendSms() {
      if (this.sms.state === 1) {
        return
      }
      if (this.phone.length < 11) {
        this.$refs.phoneInput.focus()
        return this.$toast("请输入 11 位手机号")
      }
      this.$toastLoading()
      try {
        const { code, msg } = await this.$api.auth.SMS_SEND({ phone: this.phone, phone_code: "86", use_type: 1 })
        if (code != 1000) {
          return this.$toastError(`${msg}（${code}）`)
        }
        this.setSmsCountdown()
        this.sms.state = 1
        this.smsCode = ""
        this.$refs.smsInput.focus()
        return this.$toastSuccess("已发送短信验证码")
      } catch (err) {
        this.$toastError("发送验证码失败，请稍后重试")
      }
    },
    async submit() {
      // const resMsg = {
      //   "1001": "注册成功",
      //   "1002": "绑定成功",
      //   "1003": "此手机号已被绑定",
      //   "1004": "注册成功",
      //   "1005": "登陆成功",
      // }
      if (this.phone.length !== 11 || !/^[0-9]*$/.test(this.phone)) {
        this.$refs.phoneInput.focus()
        return this.$toast("请输入 11 位手机号")
      }
      if (this.smsCode.length !== 4 || !/^[0-9]*$/.test(this.smsCode)) {
        this.$refs.smsInput.focus()
        return this.$toast("请输入 4 位短信验证码")
      }

      if (!this.agree.checked) {
        return this.$toast("请先同意条款")
      }

      this.isLoading = true
      try {
        const { code, msg } = await this.$api.auth.PHONE_LOGIN({
          phone: this.phone,
          number: this.smsCode,
          phone_code: "86"
        })
        localStorage.removeItem("phoneInput")
        if (parseInt(code) >= 2000) {
          return this.$toastError(`${msg}（${code}）`)
        }

        const { user, jwt } = msg

        this.loginUser = user

        if (jwt) {
          this.$store.commit("jwt", jwt)
        }

        if (this.$route.query.friend || this.$route.query.inviter) {
          await this.bindInviter()
        }

        const successMsg = this.$store.state.isWechat ? "验证成功" : "登陆成功"

        if (user.receiving) {
          this.$toastSuccess(successMsg)
          return this.next(user)
        }

        const coupon = await this.$api.user.GET_COUPON()
        this.$toastHide()
        if (coupon.length) {
          this.$emit("coupon", coupon)
        } else {
          this.$toastSuccess(successMsg)
        }
        this.next(user)
      } catch (err) {
        this.isLoading = false
        this.$toastError("登录失败，请稍后重试")
        throw new Error(err)
      }
    },
    next(user) {
      this.$store.commit("user", user)
      this.$store.commit("login", true)
      this.$emit("complete")
    },
  },
  created() {
    if (localStorage.getItem("phoneInput")) {
      this.phone = localStorage.getItem("phoneInput")
    }
  },
  mounted() {
    if (this.$route.query.phone) {
      this.phone = this.$route.query.phone
    }
    this.phone.length ? this.$refs.smsInput.focus() : this.$refs.phoneInput.focus()
    if (this.phone.length) {
      this.sendSms()
    }
    this.setInviter()
    this.bindInviter()
  },
  beforeDestroy() {
    this.state.timeouts.forEach(item => {
      window.clearTimeout(item)
    })
  },
}
</script>
<style lang="scss" scoped>
@import "./style.scss";

#phone {
  // padding: 30px 5% 30px 5%;
  // margin-top: 30px;

  .container {
    max-width: 500px;
    margin: 0 auto;
  }
  .btn-primary,
  .btn-secondary {
    margin-top: 20px;
  }
  .btn-back {
    position: absolute;
    left: 0;
    bottom: 100px;
    text-align: center;
    width: 100%;
    transition: all 0.1s;
    &:active {
      opacity: 0.6;
    }
    .circle {
      background: $lightBlue;
      color: $blue;
      font-size: 20px;
      border-radius: 45px;
      width: 45px;
      height: 45px;
      display: flex;
      margin: 0 auto;
      align-items: center;
      justify-content: space-around;
    }
    span {
      margin: 5px auto 0 auto;
      line-height: 1.2;
      white-space: normal;
      color: $black;
      font-size: 0.8rem;
      @include avenir();
    }
  }

  @media only screen and (max-height: 600px) {
    .btn-back {
      position: relative;
      bottom: 0;
      margin-top: 5px;
      margin-bottom: 15px;
    }
  }
  .get-code {
    font-size: 0.8rem;
    color: $blue;
    width: 150px;
    @include avenir-demi();
    text-align: right;
    transition: all 0.1s;
    &:active {
      opacity: 0.6;
    }
  }
  .clear-phone {
    color: #bbb;
  }
  .countdown {
    color: $black;
    opacity: 0.6;
    @include avenir();
    font-weight: 400;
  }
  .coupon-container {
    h1 {
      text-align: center;
      font-size: 1rem;
      padding: 0 0 10px 0;
      @include avenir-demi();
    }
  }
  .agree {
    font-size: 0;
    span {
      font-size: 0.9rem;
    }
    .text {
      opacity: 0.6;
    }
    .link {
      @include avenir();
      font-weight: 500;
      border-bottom: 1px solid #dadada;
    }
  }
  @media only screen and (max-height: 480px) {
    .login-button {
      margin-top: 10px;
    }
    .input-wrapper {
      margin-bottom: 10px;
    }
    .md-agree {
      margin-top: -10px;
    }
  }
}
</style>
